import React from "react"
import moment from "moment"

import { BrowserRouter as Router, Route, Link, Switch } from "react-router-dom"
import { push, goBack } from "react-router-redux"
import "./Transactions.css"
import Card from "../core/Card"
import SideNav from "../layout/SideNav"
import {
  Icon,
  BackIcon,
  PaperclipIcon,
  NoteIcon,
  BriefcaseIcon,
  CarIcon,
  DotIcon,
  ForwardIcon,
  ReturnOnInvestmentIcon
} from "../core/icons"
import {
  Row,
  Col,
  Button,
  Select,
  DatePicker,
  Icon as AIcon,
  Tag,
  Tooltip,
  Popover,
  Checkbox,
  Dropdown
} from "antd"
import { connect } from "react-redux"
import {
  toggleTransaction,
  loadMore,
  getTransactions,
  updateRange,
  selectFilter,
  clearFilters,
  selectPlaceFilter,
  updateTransaction
} from "./actions"
import Summary from "./Summary"
import { withPreviousDate, getPurposes } from "./reducer"
import Line from "../core/Line"
import numeral from "numeral"

const { MonthPicker, RangePicker } = DatePicker
const { Option } = Select

const Hover = ({ onHover, children, hideTooltip }) => (
  <Tooltip
    {...hideTooltip && { visible: false }}
    title={
      "Check off multiple and batch classify multiple transactions at a time."
    }
  >
    <span>
      <div className="hover">
        <div className="hover__no-hover">{children}</div>
        <div className="hover__hover">{onHover}</div>
      </div>
    </span>
  </Tooltip>
)

const mapStateToProps = ({ transactions, account, ...state }, ownProps) => ({
  ...ownProps.transaction,
  isChecked: transactions.filter_params.token_ids.includes(
    ownProps.transaction.token_id
  ),
  isAnyTransactionChecked: transactions.filter_params.token_ids.length > 0,
  purposes: getPurposes(state),
  checkboxesVisible: transactions.checkboxesVisible,
  wasChecked: transactions.wasChecked
})

const mapDispatchToProps = dispatch => {
  return {
    toggleTransaction: token_id => dispatch(toggleTransaction(token_id)),
    updateTransaction: (token_id, value) =>
      dispatch(updateTransaction(token_id, value)),
    onClickTransactionLine: token_id =>
      dispatch(push(`/transactions/${token_id}`))
  }
}

const iconType = (purpose, income_source) => {
  if (purpose == null) {
    return "Unclassified"
  }
  return income_source || purpose
}

// TODO handle locations (array), auto_detected (bool), started_at, started_at_coordinate, income_source, start_place
const TransactionLine = connect(
  mapStateToProps,
  mapDispatchToProps
)(
  ({
    wasChecked,
    checkboxesVisible,
    notes,
    photo,
    favorite_transaction_token_id,
    updateTransaction,
    purposes,
    places,
    isChecked,
    isAnyTransactionChecked,
    income_source,
    toggleTransaction,
    prevTransaction,
    isSameDate,
    token_id,
    amount,
    purpose,
    date_formatted,
    merchant,
    plaid_name,
    plaid_category,
    category,
    institution_account_name,
    onClickTransactionLine,
    style
  }) => (
    <div className="TransactionLine" style={style}>
      {isSameDate ? (
        <hr />
      ) : (
        <h1>{moment(date_formatted).format("dddd, MMMM Do YYYY")}</h1>
      )}

      <Line className="Line">
        <Col className={"purpose " + purpose} xs={24} sm={8}>
          <Hover
            hideTooltip={wasChecked}
            onHover={
              <Checkbox
                className="checkbox-large"
                onChange={() => toggleTransaction(token_id)}
                checked={isChecked}
              />
            }
          >
            {checkboxesVisible ? (
              <Checkbox
                className="checkbox-large"
                onChange={() => toggleTransaction(token_id)}
                checked={isChecked}
              />
            ) : (
              <Icon type={iconType(purpose, income_source)} selected />
            )}
          </Hover>
          <div
            className={
              "purpose-label " + (income_source || purpose || "Unclassified")
            }
          >
            <Select
              onChange={value =>
                updateTransaction({ token_id: token_id, purpose: value })
              }
              value={income_source || purpose || "Unclassified"}
            >
              {purposes.map((p, i) => (
                <option key={i} value={p}>
                  {p}
                </option>
              ))}
            </Select>
          </div>
        </Col>
        <Col xs={24} sm={9} onClick={() => onClickTransactionLine(token_id)}>
          <Row>{plaid_name || merchant}</Row>
          {/* <Row className="subtitle">{plaid_category && plaid_category[0]}</Row> */}
          <Row className="subtitle">{category}</Row>

          <Row className="subtitle">{institution_account_name}</Row>
        </Col>

        <Col xs={24} sm={4} onClick={() => onClickTransactionLine(token_id)}>
          <div
            className={amount < 0 ? "amount negative" : "amount positive"}
            style={{ textAlign: "center" }}
          >
            {numeral(amount).format("($0,0.00)")}
          </div>

          <Row
            type="flex"
            justify="space-around"
            align="middle"
            style={{ padding: "10px 30px 0" }}
          >
            {notes && (
              <Tooltip title={notes}>
                <span>
                  <NoteIcon />
                </span>
              </Tooltip>
            )}
            {photo && (
              <Tooltip title={<img width="100" src={photo.image_url} />}>
                <span>
                  <PaperclipIcon />
                </span>
              </Tooltip>
            )}
            {favorite_transaction_token_id && (
              <Tooltip title={"Automatically detected using Rules"}>
                {/* TODO link to "/account/favorite-transactions/" +
                  favorite_transaction_token_id ?*/}
                <span>
                  <ReturnOnInvestmentIcon />
                </span>
              </Tooltip>
            )}
          </Row>
        </Col>
        <Col xs={0} sm={1} onClick={() => onClickTransactionLine(token_id)}>
          {/* <ForwardIcon/> */}
          <AIcon type="right" style={{ fontSize: "27px", color: "#95a2c2" }} />
        </Col>
      </Line>
    </div>
  )
)

export default TransactionLine



// WEBPACK FOOTER //
// ./src/transactions/TransactionLine.js